import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';

platformBrowserDynamic().bootstrapModule(AppModule);

// 不显示所有打印
// console.log = function() {}
// console.error = function () {}



// WEBPACK FOOTER //
// ./src/app/main.ts